import { render, staticRenderFns } from "./LicitacaoRecursoContrarrazao.vue?vue&type=template&id=626bf9b2"
import script from "./LicitacaoRecursoContrarrazao.vue?vue&type=script&lang=js"
export * from "./LicitacaoRecursoContrarrazao.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoRecursoContrarrazao.vue?vue&type=style&index=0&id=626bf9b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports